import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { styled } from '@mui/material';
import Dialog from '@mui/material/Dialog';

import { DeviceHandoffExitLink } from 'common/deviceHandoff/components/DeviceHandoffExitLink';
import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

import '../deviceHandoffModal.scss';

const keepModalOpen = (): void => undefined;

interface Props {
    onResume: () => void;
}

export const DeviceHandoffActiveInAnotherTabScreen = ({ onResume }: Props): ReactElement => {
    const { t } = useTranslation(['patientchart', 'global']);

    return (
        <Dialog onClose={keepModalOpen} aria-labelledby="switch-user-modal" open className="switch-user-dialog-window">
            <div id="switch_user_dialog_content">
                <div id="dynamic_switch_user_content">
                    <Content id="login_content">
                        <Instruction>
                            {t('patientchart:site_activity.activity_status.resume')}{' '}
                            {t('patientchart:site_activity.activity_status.resume_activity')}
                        </Instruction>
                        <ResumeButton
                            type="button"
                            id="resumeDeviceHandoff"
                            data-testid="device-handoff-resume-button"
                            fullWidth
                            onClick={onResume}
                        >
                            {t('patientchart:site_activity.header.resume')}
                        </ResumeButton>
                    </Content>
                </div>
                <DeviceHandoffExitLink label={t('global:switchuser.log_out')} isRespondentSession />
            </div>
        </Dialog>
    );
};

const ResumeButton = styled(CISecondaryButton, { name: 'CIDeviceHandoffResumeButton' })({
    height: '56px',
    fontSize: '1rem',
    fontWeight: 500,
});

const Content = styled('div', { name: 'CIDeviceHandoffActiveInAnotherTabContent' })({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '60px',
    minHeight: '220px',
});

const Instruction = styled('p', { name: 'CIDeviceHandoffActiveInAnotherTabInstruction' })({
    margin: 0,
    textAlign: 'center',
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: 1.6,
});
